import React from 'react';

class LoginButton extends React.Component {
  render() {
    const nextUrl = encodeURIComponent(window.location.pathname + window.location.search);

    return (
      <p>
        <a data-action="login" className="slots__item-record btn btn-primary" href={`/accounts/login/?next=${nextUrl}`} role="button">Войти</a>
      </p>
    );
  }
}

export default LoginButton;
